<template>
  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4">
      <h3 class="title has-text-grey">{{ estrategia.name }}</h3>
      <login></login>
    </div>
  </div>
</template>

<script>
import Login from "@/components/FormularioLogin.vue";
import { mapGetters } from "vuex";
export default {
  name: "inicio",
  components: {
    Login
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      estrategia: "getEstrategia"
    })
  },
  methods: {}
};
</script>
